export default {
  title: '選擇掃碼模板',
  empty: '暫無模板數據',
  searchPlaceholder: '請輸入模板名稱搜索',
};
